module.exports = __webpack_public_path__ + "static/img/02-high-gain.40c818c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/amp/02-high-gain.jpg
// module id = xAUT
// module chunks = 12